import {BaseEntity} from '../../_helpers';
import {Expose} from 'class-transformer';

export class Category extends BaseEntity {
  @Expose()
  public name: String;
}
